/** Prévia de demonstração no navegador (dados de exemplo, sem servidor). Ligada só quando o build define EXPO_PUBLIC_DEMO=1. */
export const DEMO = process.env.EXPO_PUBLIC_DEMO === '1';
